// news-brief Remotion composition：60 秒热点简报，头条逐条切换 + 进度。
// 复用 ./tick 的 newsIdx 推导当前头条索引（每 5s 切，循环）。
import { AbsoluteFill, useCurrentFrame, useVideoConfig, interpolate } from 'remotion'
import { newsIdx } from './tick'
import type { NewsData } from './types'
import type { CompositionProps } from '../../remotion/ScenePlayer'
import { THEME } from '../../remotion/theme'

export const NewsBriefComposition: React.FC<CompositionProps> = ({ data }) => {
  const frame = useCurrentFrame()
  const { fps } = useVideoConfig()
  const d = data as unknown as NewsData
  const time = frame / fps
  const idx = newsIdx(data, time)
  const headlines = d.headlines || []
  const cur = headlines[idx]

  // 每条头条内的进场淡入（每 5s 周期）
  const cycleT = time % 5
  const enter = interpolate(cycleT, [0, 0.5], [0, 1], { extrapolateRight: 'clamp' })
  const exit = interpolate(cycleT, [4.5, 5], [1, 0], { extrapolateLeft: 'clamp', extrapolateRight: 'clamp' })
  const op = Math.min(enter, exit)

  return (
    <AbsoluteFill style={{ background: (data as any).bgColor || THEME.bg, fontFamily: THEME.fontSans, padding: 72, display: 'flex', flexDirection: 'column' }}>
      {/* 分类 + 计数 */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 48 }}>
        <div style={{ color: THEME.w, fontSize: 48, fontWeight: 800, padding: '10px 28px', background: THEME.p, borderRadius: 16 }}>
          {d.category || 'NEWS'}
        </div>
        <div style={{ color: THEME.t3, fontSize: 40, fontFamily: THEME.fontMono }}>
          {Math.min(idx + 1, headlines.length)}/{headlines.length}
        </div>
      </div>

      {/* 进度点 */}
      <div style={{ display: 'flex', gap: 12, marginBottom: 64 }}>
        {headlines.map((h, i) => (
          <div key={i} style={{
            flex: 1, height: 8, borderRadius: 4,
            background: i === idx ? h.color : THEME.bg3,
            opacity: i === idx ? 1 : 0.4,
          }} />
        ))}
      </div>

      {/* 当前头条 */}
      {cur && (
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', opacity: op }}>
          <div style={{
            display: 'inline-block', width: 'fit-content', marginBottom: 36,
            padding: '8px 24px', borderRadius: 12, border: `2px solid ${cur.color}`,
            color: cur.color, fontSize: 34, fontWeight: 700,
          }}>
            {cur.source}
          </div>
          <div style={{ color: THEME.w, fontSize: 76, fontWeight: 800, lineHeight: 1.2 }}>
            {cur.title}
          </div>
          <div style={{ marginTop: 40, color: THEME.t2, fontSize: 38, fontFamily: THEME.fontMono }}>{cur.time}</div>
        </div>
      )}
    </AbsoluteFill>
  )
}
